export default __webpack_public_path__ + "static/media/grid-rainbow.1dc05ea5.png";